import React from 'react';
import stylesheet from './PrivateCloudName.scss';
import dataChipStyleSheet from '../DataChip/DataChip.scss';
import { Cloud, Tip100 } from 'shared/legacy';
import Tooltip from '../Tooltip';

// This is a hack and shouldn't be copied.
//
// In some places, there is a need to change the font styling
// for this particular component. As such, we pass this
// as an arg that specifies which other component it should match.
// This may not make sense in the future depending on the level
// of tweaking needed so please don't follow this pattern!
const fontStyle = font =>
  font === 'DataChip'
    ? dataChipStyleSheet['data-chip__value']
    : stylesheet['private-cloud-name__name'];

const PrivateCloudName = ({
  tooltipText,
  name = 'Private Cloud',
  font = 'default',
}) => {
  return (
    <div className={stylesheet['private-cloud-name__layout']}>
      <Cloud className={stylesheet['private-cloud-name__cloud']} size="ty-e" />
      <span className={fontStyle(font)}>{name}</span>
      <Tooltip text={tooltipText}>
        <Tip100
          className={stylesheet['private-cloud-name__tooltip']}
          size="ty-d"
        />
      </Tooltip>
    </div>
  );
};

export default PrivateCloudName;
